<template>
  <div id="invoicingGoodsList">
    <div class="invoicingHead" style="height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicingFather/goodsPurchase')" href="javascript:;">进货单管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicingFather/addGoodsPurchase')" href="javascript:;">新增进货单</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>选择商品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="white"></div>
    <div class="invoicingHead searchContent">
      <el-button
        size="small"
        style="width:100px;"
        type="primary"
        @click="showCommodityList = true"
      >增加进货商品</el-button>
      <el-button
        size="small"
        style="width:100px;"
        type="primary"
        plain
        @click="jumpTT('/invoicingFather/editSupplier')"
      >新增加商品</el-button>
      <el-button
        size="small"
        style="width:100px;"
        type="primary"
        @click="jumpTT('/invoicingFather/editSupplier')"
      >结算</el-button>
      <div class="row" style="position: absolute;right:230px;top:13px;">
        <el-select size="small" v-model="searchInformation.repositoryId" placeholder="入库仓库">
          <el-option
            v-for="item in shopStoresList"
            :key="item.shopStoreId"
            :label="item.storeName"
            :value="item.shopStoreId"
          ></el-option>
        </el-select>
        <el-input size="small" style="margin-left:10px" placeholder="搜索商品" v-model="value"></el-input>
        <el-button size="small" style="margin-left:20px" @click="search" type="primary">搜索</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div class="content">
      <!-- 统计表格数据 -->
      <div>
        共
        <span>{{statisticalList.typeNumber}}</span>种
        <span>{{statisticalList.number}}</span>件商品，合计金额：
        <span>￥{{statisticalList.price}}</span>
      </div>
      <el-table :data="shoppingTrolley" style="width: 100%">
        <el-table-column align="center" prop="supplierName" label="进货商品" width="180">
          <template slot-scope="scope">
            <div class="row">
              <div v-if="scope.row.saleStatus == 0" class="commidityItemImg">
                <img :src="scope.row.goodsImage" alt />
              </div>
              <div v-if="scope.row.saleStatus == 1" class="commidityItemImg2">
                <img :src="scope.row.goodsImage" alt />
              </div>
              <div style="margin-left:10px;">
                <div
                  v-if="scope.row.saleStatus == 1"
                  class="goodName"
                  style="width:100px;text-align:left"
                >{{scope.row.goodsName}}</div>
                <div
                  v-if="scope.row.saleStatus == 1"
                  class="goodName"
                  style="width:100px;text-align:left"
                >{{scope.row.valueContent}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="supplierLink" label="库存单位"></el-table-column>
        <el-table-column align="center" prop="qrcStockCount" label="可用库存"></el-table-column>
        <el-table-column align="center" prop="supplierClassificationName" label="采购单位"></el-table-column>
        <el-table-column align="center" prop="goodsNum" label="采购数量"></el-table-column>
        <el-table-column align="center" prop="purchasingCost" label="采购价"></el-table-column>
        <el-table-column align="center" prop="retailPrice" label="原价"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="button5" @click="move(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <div v-if="tableData" class="block" style="float:right;margin-top:10px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-size="5"
            layout="total, prev, pager, next, jumper"
            :total="totalNumber"
          ></el-pagination>
      </div>-->
    </div>
    <div class="obs center" v-if="showCommodityList">
      <div class="row">
        <div class="pop">
          <div class="commodityHead row">
            <el-input
              size="small"
              style="width:168px;"
              placeholder="搜索商品"
              v-model="searchGoodsValue"
            ></el-input>
            <el-button
              size="small"
              style="margin-left:20px"
              @click="searchGoods(searchGoodsValue)"
              type="primary"
            >搜索</el-button>
            <div
              class="xx"
              style
              @click="showCommodityList = false, showDetail = false,goodsNum = 1,purchasingCost = 0"
            >X</div>
          </div>
          <div id="topTabs" class="leftTabs row">
            <div class="nav">
              <div
                @click="navIndex(index)"
                :class="indexNumber!== index? 'navBlock' : 'navBlock_click'"
                v-for="(item,index) in this.tableData"
                :key="index"
              >{{item.categoryName}}</div>
            </div>
            <div class="navContent">
              <div v-if="commidityList.length!== 0" class="commidity">
                <div
                  class="commidityItem row alignCenter"
                  v-for="(item,index) in commidityList"
                  :key="index"
                  @click="commidityDetail(item)"
                >
                  <div v-if="item.saleStatus == 0" class="commidityItemImg">
                    <img :src="item.goodsImage" alt />
                  </div>
                  <div v-if="item.saleStatus == 1" class="commidityItemImg2">
                    <img :src="item.goodsImage" alt />
                  </div>
                  <div style="margin-left:10px;">
                    <div v-if="item.saleStatus == 1" class="goodName">{{item.goodsName}}</div>
                    <div
                      v-if="item.saleStatus == 0"
                      class="goodName"
                      style="color:#b2b2b2"
                    >{{item.goodsName}}</div>
                    <div class="row" style="margin-top:10px;">
                      <div class="red">￥{{item.retailPrice}}</div>
                      <!-- <div class="num">规格名：{{item.retailPrice}}</div> -->
                      <div v-if="!item.isInfiniteStock" class="num">库存：{{item.qrcTotalStockCount}}</div>
                      <div v-if="item.isInfiniteStock" class="num">库存：无限库存</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="commidityList == 0" class="commidity" style="padding:20px 20px">暂无商品</div>
            </div>
          </div>
        </div>
        <!-- 增加进货商品 -->
        <div class="column">
          <div class="pop2" v-if="showDetail">
            <div class="row">
              <div class="commidityDetailImg2">
                <div v-if="commidityDetailList.saleStatus == 0" class="commidityDetailImg">
                  <img :src="commidityDetailList.goodsImage" alt />
                </div>
                <div v-if="commidityDetailList.saleStatus == 1" class="commidityDetailImg2">
                  <img :src="commidityDetailList.goodsImage" alt />
                </div>
              </div>
              <div class="comDetailRight">
                <div class="detailName">{{commidityDetailList.goodsName}}</div>
                <div class="detailInf">条形码：{{tableData2.barCode}}</div>
                <div class="detailInf">可用库存：{{tableData2.qrcStockCount}}件</div>
                <div class="detailInf">参考进货价：￥{{tableData2.costPrice}}</div>
              </div>
            </div>
            <div class="text1 row">
              <div>选择规格</div>
              <div
                @click="selectProduct(item)"
                :class="tableData2.productId!== item.productId? 'valueContent center' : 'valueContent2 center'"
                v-for="(item,index) in commidityDetailList.products"
                :key="index"
              >{{item.valueContent}}</div>
            </div>
            <div class="text1">
              进货数量
              <el-input-number
                v-model="goodsNum"
                @change="handleChange"
                :min="1"
                :max="tableData2.qrcStockCount"
                label="描述文字"
                style="margin-left: 23px;"
              ></el-input-number>
            </div>
            <div class="text1 row">
              进货价格
              <el-input
                size="small"
                v-model="purchasingCost"
                style="width:200px;margin-left: 23px;"
              ></el-input>
            </div>
            <div style="margin-left:80px;margin-top:20px;">
              <el-button size="small" style="width:100px;" type="primary" @click="selectGoods">完成</el-button>
              <!-- <el-button
                size="small"
                style="width:100px;"
                type="primary"
                plain
                @click="jumpTT('/invoicingFather/editSupplier')"
              >继续扫描</el-button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Shop_shopStores, goodsCategoryPager } from "../api";
export default {
  data() {
    return {
      searchInformation: { repositoryId: "" }, //搜索信息
      shopStoresList: [],
      value: "",
      userList: [],
      shopInformation: [],
      showCommodityList: false, //商品列表显示
      indexNumber: 0, //左侧导航栏的索引
      goodsCategoryId: "", //产品分类id
      pageNum: 1,
      //商品分类
      tableData: [],
      commidityList: [],
      commidityDetailList: [],
      totalCount: "",
      tableData2: [], //选中的商品详情
      goodsNum: 1, //商品详情的进货数量
      purchasingCost: 0, //商品详情的进货价
      showDetail: false, //商品详情显示
      shoppingTrolley: [], //购物车
      searchGoodsValue: "", //搜索商品列表
      statisticalList: {
        typeNumber: 0,
        number: 0,
        price: 0
      }
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.Shop_shopStores();
    this.goodsCategoryList(1, 9999);
    this.Goods_goodsList();
  },
  methods: {
    //移除商品
    move(e) {
      // console.log(e.productId,'1')
      for (let i in this.shoppingTrolley) {
        if (this.shoppingTrolley[i].productId == e.productId) {
          this.shoppingTrolley.splice(i, 1);
          // console.log(i,'true')
        }
      }
      var statisticalList = this.statisticalList;
      statisticalList.typeNumber = shoppingTrolley.length;
      var statisticalNumber = 0;
      var statisticalPrice = 0;
      //统计表格数据
      for (let i of shoppingTrolley) {
        statisticalNumber += i.goodsNum;
        statisticalPrice += i.goodsNum * i.purchasingCost;
      }
      statisticalList.number = statisticalNumber;
      statisticalList.price = statisticalPrice;
    },
    //选择商品 productId
    selectGoods() {
      var arr = this.tableData2; //选择的商品
      console.log(arr)
      var shoppingTrolley = this.shoppingTrolley;
      this.showDetail = false;
      var idArr = [];
      var istrue = false; //判断选中商品是否存在购物车
      var index = null;
      for (let a of shoppingTrolley) {
        idArr.push(a.productId);
      }
      for (let i in idArr) {
        if (idArr[i] == arr.productId) {
          istrue = true;
          index = i;
        } else {
          // istrue = false;
        }
      }
      if (istrue) {
        let newGoodsNum = this.goodsNum + shoppingTrolley[index].goodsNum
        this.$set(shoppingTrolley[index], 'purchasingCost', this.purchasingCost)
        this.$set(shoppingTrolley[index], 'goodsNum', newGoodsNum)
        // shoppingTrolley[index].purchasingCost = this.purchasingCost;
        // shoppingTrolley[index].goodsNum += this.goodsNum;
      } else {
        arr.purchasingCost = this.purchasingCost;
        arr.goodsNum = this.goodsNum;
        arr.goodsName = this.commidityDetailList.goodsName;
        arr.saleStatus = this.commidityDetailList.saleStatus;
        arr.goodsImage = this.commidityDetailList.goodsImage;
        shoppingTrolley.push(arr);
      }
      console.log(istrue, index, "111");
      this.goodsNum = 1; //商品详情的进货数量
      this.purchasingCost = 0; //商品详情的进货价
      console.log(this.shoppingTrolley);
      var statisticalList = this.statisticalList;
      statisticalList.typeNumber = shoppingTrolley.length;
      var statisticalNumber = 0;
      var statisticalPrice = 0;
      //统计表格数据
      for (let i of shoppingTrolley) {
        statisticalNumber += i.goodsNum;
        statisticalPrice += i.goodsNum * i.purchasingCost;
      }
      statisticalList.number = statisticalNumber;
      statisticalList.price = statisticalPrice;
    },
    //选择规格
    selectProduct(item) {
      this.tableData2 = item;
    },
    handleChange(value) {
      console.log(value);
    },
    //商品详情
    commidityDetail(item) {
      this.request
        .post("qrcapi/Goods_singleGoods", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          goodsId: item.id
        })
        .then(res => {
          console.log(res.data.products, "goodsDetail");
          if (res.code == 1) {
            this.showDetail = true;
            this.commidityDetailList = res.data;
            this.tableData2 = res.data.products[0];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //商品列表
    Goods_goodsList(goodsCategoryId, goodsName, pageSize, pageNumber) {
      if (pageSize) {
      } else {
        pageSize = 5;
      }
      if (pageNumber) {
      } else {
        pageNumber = this.pageNum;
      }
      //  商品列表(分页)
      this.request
        .post("qrcapi/Goods_goodsPager", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopId: this.shopInformation.shopId, //商店id
          goodsCategoryId: goodsCategoryId, //不传为全部商品
          goodsName: goodsName, //商品名字
          // saleStatus:'', //-1,-2 强制下架   0：下架  1：上架
          pageNumber: 1, // 当前页码
          pageSize: 99999 // 每页记录数
        })
        .then(res => {
          console.log(this.goodsCategoryId, "this.goodsCategoryId");
          console.log(res.data.pager, "获取商品列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            for (let i in res.data.pager.list) {
              this.$set(res.data.pager.list[i], "click", false);
            }

            this.commidityList = res.data.pager.list;
            // console.log(this.commidityList,'commidityList')
            this.totalCount = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.commidityList = "";
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("商品接口网络错误，不能访问");
          console.log(error);
        });
    },
    //分类列表
    goodsCategoryList(pageNo, pageSize) {
      goodsCategoryPager({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNumber: pageNo,
        pageSize: pageSize
      })
        .then(res => {
          console.log(res.data, "分类列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            var num = 0;
            this.tableData = [{ categoryName: "全部", goodsTypes: "" }];
            for (let i in res.data.pager.list) {
              this.tableData.push(res.data.pager.list[i]);
              num += res.data.pager.list[i].goodsTypes;
            }
            // this.totalCount2 = res.data.pager.totalCount;
            this.tableData[0].goodsTypes = num;
            this.goodsCategoryId = "";
            console.log(this.tableData, "tableData");
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //点击左侧tab栏
    navIndex(e) {
      this.indexNumber = e;
      console.log(e, "navIndex");
      if (e == 0) {
        this.goodsCategoryId = "";
        this.pageNum = 1;
        this.Goods_goodsList(this.goodsCategoryId);
      } else {
        this.goodsCategoryId = this.tableData[e].goodsCategoryId;
        this.pageNum = 1;
        this.Goods_goodsList(this.goodsCategoryId);
      }
    },
    searchGoods(searchGoodsValue) {
      this.Goods_goodsList(this.goodsCategoryId, searchGoodsValue); //商品列表
    },
    search() {},
    //门店列表
    Shop_shopStores(pageNo, shopStoreName, pageSize) {
      Shop_shopStores({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
        //   pageNo: pageNo,
        //   storeName: shopStoreName, //门店名称
        //   pageSize: pageSize
      }).then(res => {
        if (res.code == 1) {
          console.log(res, "素有门店");
          this.shopStoresList = res.data.list;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    }
  }
};
</script>

<style  scoped>
.searchContent {
  /* position: relative; */
  top: 120px;
}
.white {
  position: fixed;
  top: 90px;
  height: 30px;
  background: #fff;
  width: 100%;
  z-index: 100;
}
.pop {
  width: 687px;
  height: 617px;
  background: #fff;
  z-index: 2001;
  /* position: fixed; */
  border-radius: 5px;
  position: relative;
}
.pop2 {
  width: 516px;
  height: 468px;
  background: #fff;
  z-index: 2001;
  /* position: fixed; */
  border-radius: 5px;
  margin-left: 15px;
  padding: 24px;
  box-sizing: border-box;
}
.pop3 {
  width: 516px;
  height: 96px;
  background: #fff;
  z-index: 2001;
  /* position: fixed; */
  border-radius: 5px;
  margin-left: 15px;
  margin-top: 20px;
}
.obs {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.commodityHead {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 60px;
  /* position: fixed;
  top: 39px; */
  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
.leftTabs {
  /* margin-top: 59px; */
  height: 100%;
  height: calc(100% - 60px);
  position: relative;
}
.nav {
  background: #f8f8f8;
  width: 120px;
  /* height: calc(100% - 60px); */
  height: 100%;
  border-right: 1px solid #eeeeee;
  /* position: fixed; */
  overflow-y: scroll;
}
.nav::-webkit-scrollbar {
  display: none;
}
.navContent {
  width: calc(100% - 120px);
  height: 100%;
  overflow-y: scroll;
  /* margin-left: 121px; */
}
.navContent::-webkit-scrollbar {
  display: none;
}
.xx {
  color: gray;
  font-size: 15px;
  cursor: pointer;
  position: absolute;
  right: 25px;
}
.navBlock {
  /* height: 50px; */
  box-sizing: border-box;
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.navBlock_click {
  background: #fff;
  /* height: 50px; */
  box-sizing: border-box;
  /* padding-top: 20px;
  padding-left: 30px; */
  padding: 20px 30px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.commidity {
  box-sizing: border-box;
  font-size: 16px;
  padding: 20px 20px 20px 20px;
}
.commidityItem {
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.commidityItem:not(:first-child) {
  margin-top: 16px;
}
.commidityItemImg img {
  height: 50px;
  width: 50px;
}
.commidityItemImg2 img {
  height: 50px;
  width: 50px;
}
.commidityItemImg {
  position: relative;
  height: 50px;
  width: 50px;
}
.commidityDetailImg,
.commidityDetailImg2 {
  position: relative;
  width: 185px;
  height: 175px;
}
.commidityDetailImg img,
.commidityDetailImg2 img {
  width: 185px;
  height: 175px;
}
.commidityDetailImg::before,
.commidityItemImg::before {
  content: "\5DF2\4E0B\67B6";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 12px;
}
.goodName {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.red {
  color: red;
  font-size: 13px;
}
.num {
  color: #bbb;
  margin-left: 10px;
  font-size: 12px;
}
.comDetailRight {
  margin-left: 11px;
}
.detailName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 28px;
}
.detailInf {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 25px;
}
.text1 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 25px;
  margin-top: 30px;
  margin-right: 23px;
}
.valueContent {
  width: 60px;
  height: 30px;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  margin-left: 23px;
  cursor: pointer;
}
.valueContent2 {
  width: 60px;
  height: 30px;
  background: rgba(16, 142, 233, 1);
  border-radius: 3px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  margin-left: 23px;
  cursor: pointer;
}
.content {
  position: absolute;
  top: 180px;
  width: calc(100vw - 217px);
  box-sizing: border-box;
  padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/invoicingGoodsList.vue